export default "__VITE_ASSET__D5aij4u$__"